<template>
    <base-dialog :loading="loading" :value="dialog" :title="$t('common.filter_students')" :width="440" @input="onInput" @close="hide">
        <div class="form-group">
            <span class="form-label">{{ $t('common.coach') }}</span>
            <kimsa-combobox :placeholder="$t('common.select_placeholder')" dense solo with-selected-dot
                :items="coachOptions" @change="coach = $event" :value="coach" item-value="id" clearable />
        </div>

        <template v-slot:footer>
            <dialog-actions :confirm-label="$t('common.filter')" :loading="loading" @cancel="hide" @confirm="filter" />
        </template>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";

export default {
    name: "FilterStudentByCoachDialog",
    components: { BaseDialog, DialogActions, KimsaCombobox },
    props: {
        coaches: {
            type: Array,
            default: () => []
        },
        selected: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            coach: null,
        }
    },
    computed: {
        coachOptions(vm = this) {
            return vm.coaches.map(coach => ({ id: coach.id, name: coach.name }))
        },
    },
    methods: {
        show() {
            const vm = this
            vm.coach = vm.coachOptions.find(coach => coach.id === vm.selected) || null
            vm.dialog = true
        },
        hide(reset = true) {
            const vm = this
            vm.dialog = false
            if (reset) vm.reset()
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            this.coach = null
        },
        filter() {
            const vm = this
            vm.$emit('filter', vm.coach?.id || null)
            vm.hide(false)
        }
    },
}
</script>

<style scoped>
.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-label {
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}
</style>
